export const SIDE_INFO = "SIDE_INFO"
export const SIDE_ITEMS = "SIDE_ITEMS"
export const SAVE_SEARCH_HISTORY = "SAVE_SEARCH_HISTORY"
export const CLEAR_SEARCH_HISTORY = "CLEAR_SEARCH_HISTORY"
// export const CHANGE_LOCALE = "CHANGE_LOCALE"